const MERGE_GAP_MS = 2 * 60 * 1000;

function eventTime(value) {
  if (value == null) return 0;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (value instanceof Date) return value.getTime();
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.seconds === 'number') return value.seconds * 1000;
  if (typeof value._seconds === 'number') return value._seconds * 1000;
  const parsed = Date.parse(String(value));
  return Number.isFinite(parsed) ? parsed : 0;
}

function publicStatus(status) {
  if (status === 'DETECTED') return 'DEGRADED';
  return status || 'UNKNOWN';
}

export function mergeSplitOutages(outages) {
  const list = Array.isArray(outages) ? outages.slice() : [];
  list.sort((a, b) => eventTime(a.startedAt) - eventTime(b.startedAt));
  const lastByService = {};
  const merged = [];
  list.forEach((raw) => {
    const outage = { ...raw };
    const prev = lastByService[outage.serviceId];
    const prevEnd = prev ? eventTime(prev.endedAt) : 0;
    const start = eventTime(outage.startedAt);
    const prevWasIssue = prev &&
      (publicStatus(prev.severity) === 'DEGRADED' || prev.escalatedTo === 'DOWN');
    const thisIsDown = publicStatus(outage.severity) === 'DOWN';
    const closeEnough = prev && prev.endedAt && Math.abs(start - prevEnd) <= MERGE_GAP_MS;
    if (prevWasIssue && thisIsDown && closeEnough) {
      prev.severity = 'DOWN';
      prev.escalatedTo = 'DOWN';
      if (!prev.escalatedAt) prev.escalatedAt = prev.endedAt;
      prev.endedAt = outage.endedAt;
      prev.open = !!outage.open;
      lastByService[outage.serviceId] = prev;
      return;
    }
    merged.push(outage);
    lastByService[outage.serviceId] = outage;
  });
  return merged;
}
